"use strict";
exports.__esModule = true;
var utils_1 = require("../utils");
var exceptions_1 = require("../exceptions");
var defaultClickTypes = Array(6).fill("click").concat(Array(2).fill("dblclick"), Array(1).fill("mousedown"), Array(1).fill("mouseup"), Array(3).fill("mouseover"), Array(1).fill("mousemove"), Array(1).fill("mouseout"));
function defaultCanClick() {
    return true;
}
function clicker() {
    var document = window.document;
    var body = document.body;
    var config = {
        clickTypes: defaultClickTypes,
        positionSelector: defaultPositionSelector,
        showAction: defaultShowAction,
        canClick: defaultCanClick,
        maxNbTries: 10,
        logger: console,
        randomizer: null
    };
    function defaultPositionSelector() {
        if (!config.randomizer) {
            return [0, 0];
        }
        return [
            config.randomizer.natural({
                max: document.documentElement.clientWidth - 1
            }),
            config.randomizer.natural({
                max: document.documentElement.clientHeight - 1
            })
        ];
    }
    function defaultShowAction(x, y) {
        var clickSignal = document.createElement("div");
        clickSignal.style.zIndex = "2000";
        clickSignal.style.border = "3px solid red";
        clickSignal.style.borderRadius = "50%";
        clickSignal.style.width = "40px";
        clickSignal.style.height = "40px";
        clickSignal.style.boxSizing = "border-box";
        clickSignal.style.position = "absolute";
        clickSignal.style.transition = "opacity 1s ease-out";
        clickSignal.style.left = x - 20 + "px";
        clickSignal.style.top = y - 20 + "px";
        var element = body.appendChild(clickSignal);
        setTimeout(function () {
            body.removeChild(element);
        }, 1000);
        setTimeout(function () {
            element.style.opacity = "0";
        }, 50);
    }
    function clickerGremlin() {
        if (!config.randomizer) {
            throw new exceptions_1.RandomizerRequiredException();
        }
        var position, posX, posY, targetElement, nbTries = 0;
        do {
            position = config.positionSelector();
            posX = position[0];
            posY = position[1];
            targetElement = document.elementFromPoint(posX, posY);
            nbTries++;
            if (nbTries > config.maxNbTries)
                return false;
        } while (!targetElement || !config.canClick(targetElement));
        var evt = document.createEvent("MouseEvents");
        var clickType = config.randomizer.pick(config.clickTypes);
        evt.initMouseEvent(clickType, true, true, window, 0, 0, 0, posX, posY, false, false, false, false, 0, null);
        targetElement.dispatchEvent(evt);
        if (typeof config.showAction == "function") {
            config.showAction(posX, posY, clickType);
        }
        if (config.logger && typeof config.logger.log == "function") {
            config.logger.log("gremlin", "clicker   ", clickType, "at", posX, posY);
        }
    }
    utils_1.configurable(clickerGremlin, config);
    return clickerGremlin;
}
exports.clicker = clicker;
